<template>
  <div>
    <v-btn class="d-none d-sm-block" tile @click="logout"
      ><v-icon>mdi-logout</v-icon
      ><span class="d-none d-sm-block"> Logout</span></v-btn
    >
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn class="d-block d-sm-none" v-on="on"
          ><v-icon>mdi-menu</v-icon></v-btn
        >
      </template>
      <v-list>
        <v-list-item @click="logout">
          <v-icon>mdi-logout</v-icon> Logout
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { ROUTES } from "@/router/router.config";

export default {
  name: "Logout",

  methods: {
    logout() {
      this.$store
        .dispatch("users/logout")
        .then(() => this.$router.push({ name: ROUTES.login.name }))
        .catch();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.v-btn {
  position: absolute;
  top: 0px;
  right: 0px;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    height: $expansion-panel-header-min-height !important;
    top: 10px;
    right: 10px;
  }
}
</style>
